import axios from 'axios';
import ENV from '../constants/Environment.js';
export default new class ImageService {

    async getGallery() {
        const data = {
            "expression": "folder:Gallery",
            "with_field": "context|tags"
        };

        const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/gallery/${data.expression}/${data.with_field}`);
        return response.data.results;
    }

}
